// Event-day job devices (card 540f21a4): pairing, listing, changing and
// stopping the devices of one event. The organizer's (or an admin's) own
// sign-in; the server checks who may manage which event's devices.
import { serviceConsumer } from '../../network/ServiceConsumer';

const BASE = (kind, eventId) => `${process.env.REACT_APP_BASE_URL}/job-devices/${kind}/${eventId}`;

export const listDevices = (kind, eventId) => serviceConsumer('GET', BASE(kind, eventId));
export const pairDevice = (kind, eventId, body) => serviceConsumer('POST', `${BASE(kind, eventId)}/pair`, body);
export const makeDeviceLink = (kind, eventId, body) => serviceConsumer('POST', `${BASE(kind, eventId)}/links`, body);
// an Oireachtas stage check-in tablet's link, and stopping one (admins only)
export const makeStageLink = (eventId, body) =>
  serviceConsumer('POST', `${process.env.REACT_APP_BASE_URL}/oireachtas/${eventId}/stage-links`, body);
export const revokeStageTablet = (eventId, linkId) =>
  serviceConsumer('POST', `${process.env.REACT_APP_BASE_URL}/oireachtas/${eventId}/stage-links/${linkId}/revoke`, {});
export const updateDevice = (kind, eventId, linkId, body) =>
  serviceConsumer('PUT', `${BASE(kind, eventId)}/devices/${linkId}`, body);
export const revokeDevice = (kind, eventId, linkId) =>
  serviceConsumer('POST', `${BASE(kind, eventId)}/devices/${linkId}/revoke`, {});
